import React from 'react';
import './Marquee.css';

const Marquee = () => {
  const items = [
    { text: 'React', lit: true },
    { text: 'Next.js', lit: true },
    { text: 'Tailwind CSS', lit: false },
    { text: 'Node.js', lit: true },
    { text: 'PHP', lit: false },
    { text: 'Python', lit: true },
    { text: 'MySQL', lit: false },
    { text: 'PostgreSQL', lit: true },
    { text: 'AWS', lit: true },
    { text: 'Firebase', lit: false },
    { text: 'Vercel', lit: true },
    { text: 'Docker', lit: false },
  ];

  const duplicatedItems = [...items, ...items, ...items];

  return (
    <div className="marquee">
      <div className="marquee-track">
        {duplicatedItems.map((item, idx) => (
          <span key={idx} className={`marquee-item ${item.lit ? 'lit' : ''}`}>
            {item.text}
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
